var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MerchantPaymentList',{attrs:{"title":"Pending Transactions","default-status":"pending","status-options":_vm.statusOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }